export enum AGENT_HUB_MCPS {
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=862166758
     */
    BASIC_INFORMATION = 'AGENT_HUB_MCPS.BASIC_INFORMATION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=862166809
     */
    BASIC_INFORMATION_DESC = 'AGENT_HUB_MCPS.BASIC_INFORMATION_DESC',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=852626104
     */
    DEACTIVATE_WARNING_DESC = 'AGENT_HUB_MCPS.DEACTIVATE_WARNING_DESC',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=852624200
     */
    DEACTIVATE_WARNING_TITLE = 'AGENT_HUB_MCPS.DEACTIVATE_WARNING_TITLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=852525301
     */
    EDIT_MCP = 'AGENT_HUB_MCPS.EDIT_MCP',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=867425993
     */
    EXTERNAL_MCP = 'AGENT_HUB_MCPS.EXTERNAL_MCP',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=857814098
     */
    MCP = 'AGENT_HUB_MCPS.MCP',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=862166821
     */
    GRANT_TYPE_DESC = 'AGENT_HUB_MCPS.GRANT_TYPE_DESC',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=852538809
     */
    MCP_TOOLS = 'AGENT_HUB_MCPS.MCP_TOOLS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=857580180
     */
    MCP_TOOLS_ACTIVATED = 'AGENT_HUB_MCPS.MCP_TOOLS_ACTIVATED',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=862167664
     */
    MCP_SERVER_URL = 'AGENT_HUB_MCPS.MCP_SERVER_URL',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=852503283
     */
    NEW_MCP = 'AGENT_HUB_MCPS.NEW_MCP',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=855780059
     */
    NO_TOOLS_AVAILABLE = 'AGENT_HUB_MCPS.NO_TOOLS_AVAILABLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=870742921
     */
    NO_TOOLS_AVAILABLE_DESC_2 = 'AGENT_HUB_MCPS.NO_TOOLS_AVAILABLE_DESC_2',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=862218759
     */
    OAUTH2_PROTOCOL = 'AGENT_HUB_MCPS.OAUTH2_PROTOCOL',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=863202020
     */
    OAUTH2_PROTOCOL_DESC = 'AGENT_HUB_MCPS.OAUTH2_PROTOCOL_DESC',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=862218730
     */
    PROVIDER_DESC = 'AGENT_HUB_MCPS.PROVIDER_DESC',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=852621897
     */
    TOOL_ACTIVATED = 'AGENT_HUB_MCPS.TOOL_ACTIVATED',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=852690635
     */
    TOOL_DEACTIVATED = 'AGENT_HUB_MCPS.TOOL_DEACTIVATED',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=862167634
     */
    MCP_SERVER_CREATED = 'AGENT_HUB_MCPS.MCP_SERVER_CREATED',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=862167660
     */
    MCP_SERVER_UPDATED = 'AGENT_HUB_MCPS.MCP_SERVER_UPDATED',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=857815145
     */
    DELETE_MCP_DESCRIPTION = 'AGENT_HUB_MCPS.DELETE_MCP_DESCRIPTION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=870727298
     */
    MCP_SETTINGS = 'AGENT_HUB_MCPS.MCP_SETTINGS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=872206923
     */
    CONNECT_MCP_TITLE = 'AGENT_HUB_MCPS.CONNECT_MCP_TITLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=872207000
     */
    CONNECT_MCP_DESCRIPTION = 'AGENT_HUB_MCPS.CONNECT_MCP_DESCRIPTION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=872207025
     */
    CONNECT_MCP_CONNECTION_FAILED = 'AGENT_HUB_MCPS.CONNECT_MCP_CONNECTION_FAILED',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=872207179
     */
    CONNECT_MCP_CONNECTION_FAILED_DESC = 'AGENT_HUB_MCPS.CONNECT_MCP_CONNECTION_FAILED_DESC',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=872207397
     */
    CONNECT_MCP_CONNECTED = 'AGENT_HUB_MCPS.CONNECT_MCP_CONNECTED',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=873412633
     */
    CONNECT_MCP_FETCHING_TITLE = 'AGENT_HUB_MCPS.CONNECT_MCP_FETCHING_TITLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=873433976
     */
    CONNECT_MCP_FETCHING_DESC = 'AGENT_HUB_MCPS.CONNECT_MCP_FETCHING_DESC',
}
